import Joi from 'joi';
const linkSchema = Joi.object({
  path: Joi.string().allow('', null),
  properties: Joi.object({
    anchor: Joi.string().allow('', null),
    parameters: Joi.string().allow('', null),
    target: Joi.string().allow('', null),
    title: Joi.string().allow('', null)
  }),
  text: Joi.string().allow('', null)
}).unknown(true);
export default linkSchema;